import { fetchPageData } from "../utils/fetch";

export const getInitiatives = async () => {
  const endpoint = "initiatives";
  const method = "GET";
  const err = "Failed to fetch initiatives.";
  const fetchedData = await fetchPageData(endpoint, method, err);
  return fetchedData;
};

export const updateInitiative = async (token, initiativeId, initiativeData) => {
  const endpoint = initiativeId ? `initiative/${initiativeId}` : "initiative";
  const err = initiativeId
    ? "Editing initiative failed."
    : "Creating initiative failed.";
  const method = initiativeId ? "PUT" : "POST";
  const fetchedData = await fetchPageData(
    endpoint,
    method,
    err,
    token,
    initiativeData
  );
  return fetchedData;
};

export const deleteInitiative = async (token, initiativeId) => {
  const endpoint = `initiative/${initiativeId}`;
  const method = "DELETE";
  const err = "Deleting initiative failed.";
  const fetchedData = await fetchPageData(endpoint, method, err, token);
  return fetchedData;
};
